import { TextField, Grid } from "@mui/material";
import { H5} from "../components/Typography";
import { FC } from "react";

// component props interface
interface CustomButtonProps {
  title?: string;
  helperText?: string;
  textColor?: string;
  mdWidth?: string;
  xsWidth?: string;
  handleInputChange?: any;
  error?: any;
  value?: string;
  width?: string;
  disabled?: boolean
}

const CustomTextInput: FC<CustomButtonProps> = ({
  title,
  error,
  helperText,
  handleInputChange,
  mdWidth,
  xsWidth,
  value,
  width,
  disabled
}) => {
  return (
    <Grid
      sx={{
        flexDirection: "column",
        display: "flex",
        width: {
            xs:  "100%",
            md:  "50%",
          },
      }}
    >
      <H5
        fontWeight={"550"}
        sx={{
          textAlign: "left",
          fontFamily: "'Poppins', sans-serif",
          mt: 1,
        }}
      >
        {title}
      </H5>
      <TextField
      disabled={disabled}
        onChange={handleInputChange}
        fullWidth
        variant="outlined"
        margin="normal"
        sx={{
          width: {
            xs: xsWidth ? xsWidth : "100%",
            md: mdWidth ? mdWidth : "95%",
          },
          marginTop: {
            xs: 2,
            sm: 2,
            md: 1,
          },
        }}
        InputProps={{ style: { height: "40px",
     } }}
        name="city"
        value={value ? value : ""}
        error={!!error}
        helperText={helperText}
      />
    </Grid>
  );
};

export default CustomTextInput;
